namespace $.$$ {

	export class $shm_wordstat_filter_section extends $.$shm_wordstat_filter_section {

		section_rows() {
			return [
				this.Title(),
				... this.expanded() ? this.content() : [],
			]
		}

		@ $mol_mem
		expanded( next?: boolean ) {
			return $mol_state_local.value( this.toString() + '.expanded', next ) ?? true
		}

	}

}
